import { BaseError } from './base';

export class InvalidWalletProviderKeyError extends BaseError {
  // eslint-disable-next-line custom-rules/require-single-object-param
  constructor(value: string) {
    super({
      cause: null,
      code: 'invalid_wallet_provider_key',
      docsUrl: null,
      name: 'InvalidWalletProviderKeyError',
      shortMessage: `Invalid wallet provider key: ${value}. Key must be in the format of <normalizedWalletNameWithChain>:<walletProviderType>[:<suffix>]`,
    });
  }
}
